import { VehicleMapDataPoint } from "../../../api/types/VehicleMap";
import { isNonTrip } from "./tripClassification";

// Trip numbers belong to trips. Numbering straight off the array index
// gives one to every heartbeat too, which is what had a day of three runs
// reading "Trip 2", "Trip 4", "Trip 6" - the numbers in between went to
// non-trips, and with those hidden there was nothing on screen the missing
// numbers could refer to.
//
// This is the one place that decides it. The trip list worked it out for
// itself and the map did not, so the same trip was "Trip 2" in the list and
// "Trip 4" in its hover tooltip, its cluster popup and its detail header.
//
// Counted across the whole day rather than the visible rows, so turning on
// "show non-trips" doesn't renumber the trips around them. Keyed by the
// index in the array given, which stays the trip's identity - it is what
// the trip key is built from, and that must not move with the label.
export const tripDisplayNumbers = (
  trips: VehicleMapDataPoint[][]
): Map<number, number> => {
  const numbers = new Map<number, number>();
  let counter = 0;
  trips.forEach((points, tripIndex) => {
    if (isNonTrip(points)) return;
    counter += 1;
    numbers.set(tripIndex, counter);
  });
  return numbers;
};

// A non-trip has no number at all, so callers that must show something fall
// back to its position. Used where the type demands a number - the renderer
// carries one per drawn route, and a non-trip can be drawn when the user
// has asked to see them.
export const tripDisplayNumberOr = (
  numbers: Map<number, number>,
  tripIndex: number
): number => numbers.get(tripIndex) ?? tripIndex + 1;
